import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BoundariesActions from "../../../store/actions/Boundaries";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";
import * as CityActions from "../../../store/actions/City";
import * as LocalityActions from "../../../store/actions/Locality";
import * as ZoneActions from "../../../store/actions/Zone";
import Button from "sushiweb/Button";
import NoFooterModal from "../../Common/NoFooterModal";
import { BottomSectionModal } from "../../../constants/assets/containers";
import ToggleSwitch from "../../Common/ToggleSwitch";
import variables from "../../../constants/assets/variables";
import { setStatus } from "../../../store/actions/User";

const FiltersModal = (props) => {
  const {
    cityFilters = false,
    localityFilters = false,
    zoneFilters = false,
    modalState,
    handleClose,
    activeFilters,
    getLocalityList,
    getZoneList,
    modalHeading,
    getZone,
    getCityList,
    nextPageCity,
    nextPageLocality,
    nextPageZone,
    getCity,
    getLocality,
    setStatus,
    updateActiveFilters
  } = props;
    const [initialState, setInitialState] = useState({
    city_id: activeFilters.city_id ? activeFilters.city_id : 0,
    zone_id: activeFilters.zone_id ? activeFilters.zone_id : 0,
    city_name: activeFilters.city_name ? activeFilters.city_name : "",
    zone_name: activeFilters.zone_name ? activeFilters.zone_name : "",
    });

  const [priorityFlag, setPriorityFlag] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleClose();
    updateActiveFilters(initialState);
  };

  const handleClearFilters = () => {
    const clearedValues = {
      city_id: 0,
      zone_id: 0,
      city_name: "",
      zone_name: ""
    };

    setInitialState(clearedValues);
    updateActiveFilters(clearedValues);
    handleClose()
  };

  const handleChange = (type1, val1, type2, val2) => {
    let values = { ...initialState };
    values[type1] = val1
    values[type2] = val2
    setInitialState(values);
  };

  useEffect(() => {
    setPriorityFlag(true);
  }, [activeFilters]);

  return (
    <NoFooterModal
      header={true}
      heading={modalHeading}
      handleClose={handleClose}
      id="citiesFilterFilterModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          <Button
            data-testid="filterFeatureBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
          >
            Clear
          </Button>
          <Button
            data-testid="submitButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            Apply
          </Button>
        </BottomSectionModal>
      }
    >
      <div>
        {cityFilters &&
        <InfiniteScrollDropdown
          id="cityFilterDropdown"
          className="sushi-dropdown"
          priorityFlag={priorityFlag}
          getActiveList={getCityList}
          nextPage={nextPageCity}
          resKey="cities"
          keyName="city_id"
          labelKey="city_name"
          getDataLabelKey="city.city_name"
          keyTypeToSet="id"
          activeFilters={{ city_id:initialState.city_id}}
          label="City"
          modalState={"Filter"}
          handleChange={(_key, val_key_type_set, [], val) => {
            handleChange("city_id", val_key_type_set, "city_name", val.city_name)}
          }
          remoteSearchApplicable={true}
          remoteSearchKey="startswith"
          getActiveItemById={getCity}
          activeElement={getCity}
        />}
        {localityFilters && initialState.city_id != "0" &&
        <InfiniteScrollDropdown
          id="activeLocalityDropdown"
          className="sushi-dropdown"
          priorityFlag={priorityFlag}
          getActiveList={getLocalityList}
          appliedFilters={{ city_id: initialState.city_id }}
          nextPage={props.nextPageLocality}
          resKey="localities"
          modalState={"Filter"}
          keyName="locality_id"
          labelKey="locality_name"
          getDataLabelKey="locality.locality_name"
          keyTypeToSet="id"
          label="Locality"
          handleChange={(_key, val_key_type_set, [], val) => handleChange("locality_id", val_key_type_set, "locality_name", val.locality_name)}
          remoteSearchApplicable={true}
          remoteSearchKey="startswith"
          getActiveItemById={getLocality}
        />
        }
        {zoneFilters && initialState.city_id != "0" &&
          <InfiniteScrollDropdown
            id="zoneIDSelectionDropdown"
            className="sushi-dropdown"
            priorityFlag={priorityFlag}
            getActiveList={getZoneList}
            appliedFilters={{ city_id: initialState.city_id }}
            nextPage={props.nextPageZone}
            resKey="zones"
            modalState={"Filter"}
            keyName="zone_id"
            labelKey="zone_name"
            activeFilters={{ zone_id:initialState.zone_id}}
            getDataLabelKey="zone.zone_name"
            keyTypeToSet="id"
            label="Select Zone"
            handleChange={(_key, val_key_type_set, [], val) => handleChange("zone_id", val_key_type_set, "zone_name", val.zone_name)}
            remoteSearchApplicable={true}
            remoteSearchKey="startswith"
            getActiveItemById={getZone}
            activeElement={getZone}
          />
        }
      </div>
    </NoFooterModal>
  );
}

const EntityContainer = styled.div`
  border: 1px solid ${variables.grey300};
  border-radius: 8px;
  background: ${variables.grey100};
  margin-bottom: 10px;
  margin-right: 10px;
`;

function mapStateToProps(state) {
  const {City, Locality, Zone} = state;
  return {
    cityList: City.cityList,
    nextPageCity: City.nextPage,
    localityList: Locality.localityList,
    nextPageLocality: Locality.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getCityList: bindActionCreators(CityActions.getCityList, dispatch),
    getCity: bindActionCreators(CityActions.getCity, dispatch),
    getLocalityList: bindActionCreators(
        LocalityActions.getLocalityList,
        dispatch
    ),
    getZoneList: bindActionCreators(ZoneActions.getZoneList, dispatch),
    getZone: bindActionCreators(ZoneActions.getZone, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FiltersModal);
